module.exports = __webpack_public_path__ + "static/media/addons.db574655.svg";